import $ from 'jquery';
import Utils from 'Utils';

const load = Utils.once(() => {
  // eslint-disable-next-line no-multi-assign
  window.$ = window.jQuery = $;

  return $.ajax({
    url: process.env.HUYA_APP_TTURL,
    dataType: 'script',
    cache: true,
  })
})

const getTT = callback => {
  if (typeof callback === 'function') {
    load().done(() => {
      callback(window.TT)
    })
  }
}

export default getTT;
